module.exports = __webpack_public_path__ + "img/59.e856c1f7.png";